import React from "react";
import { TableContentCollectionSummaryReport } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const headerNames = this.props.headerNames;
        const grossTotal = this.props.grossTotal;
        const netTotal = this.props.netTotal;

        return (
            <div>
                <h3><center><u>Collection Summary Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Current Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                    <table className="table table-bordered pb-3">
                        <thead>
                            <tr>
                              <th rowSpan="2">Welfare Society</th>
                              <th rowSpan="2">Gross Amount</th>
                              <th rowSpan="2">Net Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <TableContentCollectionSummaryReport
                                data={reportData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                        <tfoot>
                            <tr>
                              <th colSpan="1">Total</th>
                              <th style={{ textAlign: "right" }}>{grossTotal.toFixed(2)}</th>
                              <th style={{ textAlign: "right" }}>{netTotal.toFixed(2)}</th>
                            </tr>
                          </tfoot>
                    </table>
            </div>
        );
    }
}